import FormVM from './form-vm.vue';
import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  init(node) {
    console.log('Kadenze.InstructorModuleForm Init function called');

    const vm = new Vue({
      components: {
        'form-vm': FormVM
      },
      data: {
        courseId: node.dataset.courseid,
        learningModule: JSON.parse(node.dataset.learningModule),
        modulables: JSON.parse(node.dataset.modulableListing)
      }
    });

    vm.$mount(node);
  }
};
